import React, { useState, useEffect, useRef } from 'react';
import './header.css';
import AccountSettingsIcon from '../../../images/account_settings_icon.svg';
import ChevronUp from '../../../images/account_settings_chevron_up.svg';
import ChevronDown from '../../../images/account_settings_chevron_down.svg';
import T from 'i18n-react';
import AccountSettingIcon from '../../../images/header_menubar_account_settings.svg';
import LogoutIcon from '../../../images/header_menubar_logout.svg';
import { useDispatch } from 'react-redux';

const AccountSettingsDropdown = props => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    var enLangButtonStyle = 'myAccountLangButton';
    var frLangButtonStyle = 'myAccountLangButton';
    if (props.lang === 'fr') {
        enLangButtonStyle += ' myAccountLangButton_unselected';
        frLangButtonStyle += ' myAccountLangButton_selected fr_selected';
    } else {
        enLangButtonStyle += ' myAccountLangButton_selected en_selected';
        frLangButtonStyle += ' myAccountLangButton_unselected';
    }

    const handleLangClick = (lang) => {
        if (props.langHandler) {
            props.langHandler(lang);
            localStorage.setItem('app_language', lang);
            dispatch({ type: 'SAVE_LANGUAGE_PREFS' });
            document.cookie = `langPref=${lang}; path=/; max-age=${365 * 24 * 60 * 60}`;
        }
    };

    const handleItemClick = (action) => {
        props.handleButtonClick(action);
        setIsOpen(false);
    };

    return (
        <div className={props.layoutType === 'mobile' ? 'myAccountDropdownMobile' : 'myAccountDropdown'} ref={dropdownRef}>
            <div className='dropdownHeader' onClick={toggleDropdown}>
                <img src={AccountSettingsIcon} alt="Account Settings" className='headerMenubarMyAccountIcon' />
                {props.layoutType !== 'mobile' && <div className='headerMenubarMyAccount'>{T.translate('HeaderMenuBar.labels.MyAccount')}</div>}
                <img src={isOpen ? ChevronUp : ChevronDown} alt="Chevron" />
            </div>
            {isOpen && (
                <div className={props.layoutType === 'mobile' ? 'myAccountDropdownContentMobile' : 'myAccountDropdownContent'}>
                    {props.loginComplete && props.pathname && !props.pathname.startsWith('/register') &&
                        <div className="myAccountDropdownItem" onClick={() => handleItemClick('settings')}>
                            {props.layoutType === 'mobile' && <img src={AccountSettingIcon} />}
                            <span className='myAccountText'>{T.translate('HeaderMenuBar.labels.AccountSettings')}</span>
                        </div>
                    }
                    {props.loginComplete &&
                        <div className="myAccountDropdownItem" onClick={() => handleItemClick('logout')}>
                            {props.layoutType === 'mobile' && <img src={LogoutIcon} />}
                            <span className='myAccountText'>{T.translate('HeaderMenuBar.labels.SignOut')}</span>
                        </div>
                    }
                    {!props.loginComplete &&
                    <div className='myAccountDropdownItem' onClick={() => handleItemClick('login')}>
                        {props.layoutType === 'mobile' && <img src={AccountSettingIcon} />}
                        <span className='myAccountText'>{T.translate('Common.SignIn')}</span>
                    </div>
                    }
                    <div className='myAccountBorderSeparator' />
                    <div className='myAccountDropdownItem'>
                        <div className='myAccountLangToggle'>
                            <div className={enLangButtonStyle}
                                onClick={() => handleLangClick('en')}>
                                <span>En</span>
                            </div>
                            <div className={frLangButtonStyle}
                                onClick={() => handleLangClick('fr')}>
                                <span>Fr</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AccountSettingsDropdown;